import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';

import CustomModal from '../modal';

const { Title, Paragraph } = Typography;

const AboutGlosModal = ({ open, onClose }) => (
  <CustomModal
    open={open}
    onOk={onClose}
    onCancel={onClose}
    footer={null}
    className="announcementModal"
    width={700}
    bodyStyle={{ maxHeight: '65vh', overflowY: 'auto' }}
  >
    <div style={{ padding: 10 }}>
      <Title level={2} style={{ fontSize: 24 }}>
        About GLOS
      </Title>
      <Paragraph style={{ fontSize: 16 }}>
        {'The '}
        <a
          href="https://glos.org"
          target="_blank"
          rel="noreferrer"
        >
          Great Lakes Observing System (GLOS)
        </a>
        {' is a nonprofit and certified Regional Association of the '}
        <a
          href="https://ioos.noaa.gov"
          target="_blank"
          rel="noreferrer"
        >
          U.S. Integrated Ocean Observing System
        </a>
        {' enterprise.'}
      </Paragraph>
      <Paragraph style={{ fontSize: 16 }}>
        Observing technologies are deployed and maintained by the Great Lakes
        regional network of federal, state, university, nonprofit, and community
        partners, comprising the &ldquo;observing system.&rdquo; GLOS supports these observing
        partners to address local and regional needs, with the aim to advance and
        expand technology throughout the region: to better understand the lakes,
        and to better inform the public of risks to life and property.
      </Paragraph>
      <Paragraph style={{ fontSize: 16 }}>
        <strong>
          GLOS built Seagull to connect the people of the Great Lakes region
          to the water through high-quality, up-to-date information from the
          region&rsquo;s observing network.
        </strong>
      </Paragraph>
      <a
        href="https://glos.org/about-glos/"
        target="_blank"
        rel="noreferrer"
      >
        Learn more about GLOS
      </a>
    </div>
  </CustomModal>
);

AboutGlosModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

AboutGlosModal.defaultProps = {
  open: false,
  onClose: () => {},
};

export default AboutGlosModal;
